import App from '../App';
import { connect } from 'react-redux';
import { SpecsActionCreator, FrameworkActionCreator, AppointmentActionCreator, MenusActionCreator, NewVehicleActionCreator, ROHistoryActionCreator, VehiclesActionCreator, CustomerActionCreator, AdditionalServicesActionCreator, WebOpsActionCreator, RepairOrdersActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    initialLoadDone: state.Framework.initialLoadDone,
    token: state.Framework.rtsToken,
    specData: state.Specs.specs,
    theme: state.Framework.theme,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    tokenErrMsg: state.Framework.tokenErrMsg,
    custInfo: state.Customer.Customer,
    appointment: state.Appointment,
    serviceDocsSpecs: state.Specs.serviceDocsSpecs,
    recallData: state.AdditionalServices.recallData,
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    waitOnRecall: state.Framework.waitOnRecall,
    noAutoRecall: state.Framework.noAutoRecall,
    eraError: state.Framework.eraError,
    logId: state.Specs.specs?.logId,
    countryCode: state.Framework.dealerCountry,
    languageCode: state.Framework.dealerLangCode,
    locale: state.Framework.locale,
    serviceDocsFlag: state.Framework.serviceDocsFlag,
    osdLaunched: state.Framework.osdLaunched ? state.Framework.osdLaunched : '',
    viewServiceHistFlag: state.Framework.viewServiceHistFlag,
    portalLaunched: state.Framework.portalLaunched ?? '',
    tlmId: state.Framework.tlmId,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    isCookiesEnabled: state.Framework.isCookiesEnabled,
    custError: state.Customer.errMsg,
    decodeErr: state.Vehicles.decodedData.decodeErr,
    servicesError: state.AdditionalServices.allServices.returnCode,
    recallError: state.AdditionalServices.recallData.returnCode,
    quickTimesError: state.QuickTimes.error,
    rmTimesError: state.RMTimes.error,
    menuError: state.Menus.allMenus.returnCode,
    vehError: state.Vehicles.errMsg,
    serviceDocsError: state.Specs.serviceDocsSpecs?.returnCode,
    webOpsError: state.WebOps.returnCode,
    frameworkError: state.Framework.error,
    frameworkTealiumAccount: state.Framework.tealiumAccount,
    loggingCustOff: state.Customer.loggingCustOff,
    repairOrderError: state.RepairOrders.errMsg,
    roHistoryError: state.ROHistory.allRoHistory.errMsg,
    MCData: state.AdditionalServices.maintContractData,
    waitOnMC: state.Framework.waitOnMC,
    desktopOrMobile: state.Framework.desktopOrMobile,
    loading: state.Customer.loading,
    vwDeepLinkMileage: state.Framework.vwDeepLinkMileage,
    vwVariant: state.Framework.vwVariant,
    vwKeyword: state.Framework.vwKeyword,
    vwProvider: state.Framework.vwProvider,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    getSpecs: SpecsActionCreator.GetSpecs,
    updateTheme: FrameworkActionCreator.updateTheme,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    getTokenData: FrameworkActionCreator.getTokenData,
    setPreviewFlag: FrameworkActionCreator.setPreviewFlag,
    setAddlTrackData: FrameworkActionCreator.SetAddlTrackData,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearMenusState: MenusActionCreator.ClearMenusState,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    getServiceDocsSpecs: SpecsActionCreator.GetServiceDocsSpecs,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    clearCheckedWebOps: WebOpsActionCreator.ClearCheckedWebOps,
    setWaitOnRecall: FrameworkActionCreator.SetWaitOnRecall,
    setNoAutoRecall: FrameworkActionCreator.SetNoAutoRecall,
    setDesktopOrMobile: FrameworkActionCreator.SetDesktopOrMobile,
    setPreviousToken: FrameworkActionCreator.SetPreviousToken,
    toggleLocale: FrameworkActionCreator.setLocale,
    clearRO: RepairOrdersActionCreator.ClearROState,
    logCustOff: CustomerActionCreator.LogCustOff,
    waitForLogOff: CustomerActionCreator.WaitForLogOff,
    setWaitOnMC: FrameworkActionCreator.SetWaitOnMC,
    clearMaintContractData: AdditionalServicesActionCreator.ClearMaintContractData,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setVwDeepLinkMileage: FrameworkActionCreator.SetVwDeepLinkMileage,
    setVwDeepLinkTrackData: FrameworkActionCreator.SetVwDeepLinkTrackData,
    clearAddlTrackCustInfo: FrameworkActionCreator.ClearAddlTrackCustInfo,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);